import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=7bac5458&scoped=true&"
import script from "./ProductContent.vue?vue&type=script&lang=js&"
export * from "./ProductContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=7bac5458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac5458",
  null
  
)

export default component.exports